import { Response } from '@src/interface/api/response.interface'
import client from '@src/lib/api/client'
import { VendorInfo } from './types'

export interface CreateVendorInfoResponse extends Response {
	data: {
		inserted_item: VendorInfo
	}
}

export type CreateVendorInfoPayload = {
	name: string
	profile_img: File
	vendor_store_link: string
	company_description: string
	ceo_name: string
	phone: string
	email: string
	address: string
	sales_report: File
	sales_report_number: string
	business_registration: File
	business_registration_number: string
	company_name: string
}

export const createVendorInfo = async (
	vendorInfo: CreateVendorInfoPayload,
): Promise<CreateVendorInfoResponse> => {
	const formData = new FormData()
	for (const [k, v] of Object.entries(vendorInfo)) {
		formData.append(k, v)
	}

	const response = await client.post<CreateVendorInfoResponse>(`vendors/info`, formData, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	})

	return response.data
}
